/* Title.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJifeI%7Bgrid-area%3Atitle%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgxzFw%7Bfont%3Avar(--ds-font-heading-large%2Cnormal%20653%2024px%2F28px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
import React from 'react';
import { Inline as CompiledInline } from '@atlaskit/primitives/compiled/inline';
const compiledStyles = {
  root: "_1xC2CJifeI _2sNsIgxzFw"
};
export const Title = ({
  children
}: React.PropsWithChildren<unknown>): React.JSX.Element => {
  return <CompiledInline xcss={compiledStyles.root} alignBlock="center" space="space.100">
			{children}
		</CompiledInline>;
};